import React from 'react';
import { MDBBtn, MDBIcon } from 'mdb-react-ui-kit';
import { useTranslation } from 'react-i18next';

export default function WelcomeStep({ onComplete, stepId }) {
  const { t } = useTranslation();
  
  const handleContinue = () => {
    onComplete(stepId);
  };

  return (
    <div className="h-100 d-flex flex-column">
      <div className="flex-grow-1" style={{ overflow: 'auto' }}>
        <div className="text-center py-4">
          <MDBIcon fas icon="user-shield" size="4x" className="text-primary mb-4" />
          
          <h2 className="mb-4">{t('Welcome to Administrator Onboarding!')}</h2>
          
          <div className="mx-auto" style={{ maxWidth: '600px' }}>
            <p className="lead mb-4">
              {t('As an administrator of your company, you have extended rights and responsibilities on our platform.')}
            </p>
            
            <p className="mb-4">
              {t('We have a few points for you that we would like to show you. Please read these points, update individual queries, and confirm that you have read and understood everything and of course also accept it.')}
            </p>
            
            <p className="mb-4">
              {t('In the following steps, we will work together with you to optimally set up your company so that you can focus on what is essential for all other topics:')}
            </p>
            
            <div className="text-start mb-5">
              <div className="d-flex align-items-center mb-3">
                <MDBIcon fas icon="tags" className="text-success me-3" />
                <span><strong>{t('Assign topic areas:')} </strong>{t('Select the relevant subject areas for your company')}</span>
              </div>
              <div className="d-flex align-items-center mb-3">
                <MDBIcon fas icon="presentation" className="text-info me-3" />
                <span><strong>{t('Submit presentations:')} </strong>{t('There are new presentation areas')}</span>
              </div>
              <div className="d-flex align-items-center mb-3">
                <MDBIcon fas icon="file-contract" className="text-warning me-3" />
                <span><strong>{t('Terms of use:')} </strong>{t('General consent to the use of provided content')}</span>
              </div>
            </div>
            
            <p className="text-muted mb-4">
              {t('The onboarding takes about 5-10 minutes and ensures that you can use all administrator functions optimally and efficiently.')}
            </p>
            
            <p className="text-muted">
              <strong>{t('Please note that you can only access your account after you have read and confirmed everything.')}</strong>
            </p>
          </div>
        </div>
      </div>

      <div className="flex-shrink-0 text-center py-3">
        <MDBBtn 
          color="primary" 
          size="lg"
          onClick={handleContinue}
          className="px-5"
        >
          <MDBIcon fas icon="arrow-right" className="me-2" />
          {t("Let's go!")}
        </MDBBtn>
      </div>
    </div>
  );
}